import Flexbox from "commons/components/Flexbox";
import React from "react";
import styled from "styled-components/macro";
import FieldJPG from "commons/images/field.jpg";
import FieldMedium from "commons/images/field_medium.webp";
import FieldLarge from "commons/images/field_large.webp";
import CardStack from "./components/CardStack";
import { Link } from "react-router-dom";
import { BREAKPOINTS } from "commons/util/breakpoints";
import ErrorBoundary from "App/ErrorBoundary";
import { cards as cardsInit, descriptions, descriptionsOpposite } from "./content.const";
import DescriptionList from "./components/DescriptionList";
import CTASection from "./components/CTASection";
import { useMediaQuery } from "commons/util/useMediaQuery";
import { useTranslation } from "react-i18next";

const Box = styled(Flexbox)`
  font-family: "Stack Sans Text", sans-serif;
  color: var(--brown-100);
`;

const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  width: 420px;
  height: calc(100vh + 40px);
  flex-shrink: 0;
  font-weight: 300;
  margin-right: auto;
  background-color: var(--neutral-200);
`;

const Main = styled.div`
  position: fixed;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: calc(100% - 420px);
  background-image: url(${FieldLarge});
  background-size: cover;
  background-position: bottom left;
  overflow: hidden;

  @media (max-width: ${BREAKPOINTS.medium}) {
    background-image: url(${FieldMedium});
    position: relative;
    width: auto;
    height: calc(clamp(320px, 65vh, 640px) + 160px);
    padding-top: 80px;
    padding-bottom: 80px;
  }

  @supports not (background-image: url(${FieldMedium})) {
    .hero {
      background-image: url(${FieldJPG});
    }
  }
`;

const Footer = styled.footer`
  font-size: 14px;
  background-color: var(--brown-190);
  padding: 12px 0 12px 32px;
`;

const PrivacyPolicyLink = styled(Link)`
  color: var(--brown-160);

  &:hover {
    text-decoration: underline;
  }
`;

function Waitlist() {
  const isScreenMaxMedium = useMediaQuery(BREAKPOINTS.medium);
  const { t } = useTranslation();

  if (isScreenMaxMedium) {
    return (
      <Box flexDirection="column">
        <DescriptionList descriptions={descriptions} />
        <DescriptionList descriptions={descriptionsOpposite} isOpposite />

        <Main>
          <CardStack cards={cardsInit} />
        </Main>

        <CTASection />

        <Footer>
          <PrivacyPolicyLink to="/privacy">{t("PrivacyPolicy.PrivacyPolicy")}</PrivacyPolicyLink>
        </Footer>
      </Box>
    );
  }
  return (
    <Box>
      <Sidebar>
        <DescriptionList descriptions={descriptions} />

        <DescriptionList descriptions={descriptionsOpposite} isOpposite />

        <CTASection />
        <Footer>
          <PrivacyPolicyLink to="/privacy">{t("PrivacyPolicy.PrivacyPolicy")}</PrivacyPolicyLink>
        </Footer>
      </Sidebar>

      <Main>
        <CardStack cards={cardsInit} />
      </Main>
    </Box>
  );
}

export default ErrorBoundary(Waitlist);
